import { ChoiceGroup, Label, Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { Data } from '../../data/Data';
import { DataCommercialisation } from '../../data/DataCommercialisation';
import { DataCompte } from '../../data/DataCompte';
import { DataDemande } from '../../data/DataDemande';
import { DataDocument, TYPES_DOCUMENT } from '../../data/DataDocument';
import { DataOperation } from '../../data/DataOperation';
import { DataTypeMandat, IDS_TYPE_MANDAT } from '../../data/DataTypeMandat';
import { IDS_TYPE_TRANSMISSION } from '../../data/DataTypeTransmission';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { CheckboxesAcquereurs } from '../Checkbox/CheckboxesAcquereurs';
import ComboBoxCategorieIntervenantEXTPersonne from '../ComboBox/ComboBoxCategorieIntervenantEXTPersonne';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxCompteCommercialisant } from '../ComboBox/ComboBoxCompteCommercialisant';
import { ComboBoxDemandeStandard } from '../ComboBox/ComboBoxDemandeStandard';
import { ComboBoxDocument } from '../ComboBox/ComboBoxDocument';
import ComboBoxIntervenantEXTPersonne from '../ComboBox/ComboBoxIntervenantEXTPersonne';
import ComboBoxIntervenantEXTSociete from '../ComboBox/ComboBoxIntervenantEXTSociete';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ComboBoxReservation } from '../ComboBox/ComboBoxReservation';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { ComboBoxTypeTransmission } from '../ComboBox/ComboBoxTypeTransmission';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerEmail } from '../Picker/PickerEmail';
import { FicheEnvoiEmail } from './FicheEnvoiEmail';

export class FicheDemande extends Component {

    static defaultProps = {
        idDemande: undefined,
        idDemandeADupliquer: undefined,
        idOperation: undefined,
        idReservation: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        demande: {
            dateDemande: Scriba.date().getChaineISOFromDate(new Date(Date.now())),
        },
        categorieIntervenantEXTPersonneSelectionnee: {},
        destinataires: [],
        emailsSelectionnes: [],
        from: "",
        idIntervenantEXTSocieteSelectionne: 0,
        idSocieteSelectionne: 0,
        idsTypesMandatsOperationnels: [],
        sujet: "",
        typeDestinataireSelectionne: 0,
        documentSelectionne: 0,
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheDemande.defaultState };
    };

    _afficherPanelEnvoiEmail = () => {

        // Avant d'afficher le panel, on récupérère l'adresse mail de l'expéditeur (i.e. celle du back office)
        // Et on met à jour le sujet selon si une opération a été sélectionnée ou non

        const { idOperation, idReservation } = this.state.demande;
        const { sujet } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Initialisation du formulaire en cours..."
        });

        let promises = [Data._getAdresseEmailFromBackOffice()];
        if (!!idOperation)
            promises.push(DataOperation._chargementOperationEtLotCommercial(idOperation, idReservation));

        Promise.all(promises).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const email = responseFetch[0].reponseAPIobjet || "";
                let state = {
                    afficherPanelEnvoiEmail: true,
                    from: email,
                };

                if (!!idOperation) {
                    const infoOperationEtLotCommercial = responseFetch[1].reponseAPIobjet[0] || "";
                    if (infoOperationEtLotCommercial !== "") {
                        const ville = infoOperationEtLotCommercial['ville'];
                        const nomCommercial = infoOperationEtLotCommercial['nomCommercial'];
                        const numero = infoOperationEtLotCommercial['numero'] !== null ? ' - ' + infoOperationEtLotCommercial['numero'] : '';
                        const acquereurs = infoOperationEtLotCommercial['acquereurs'] !== null ? ' - ' + infoOperationEtLotCommercial['acquereurs'] : '';
                        state.sujet = `${ville} - ${nomCommercial} / ${sujet} ${numero} ${acquereurs}`;
                    }
                    else {
                        state.sujet = `${sujet}`;
                    }
                }

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

        this.setState({});
    };

    _chargementDonnees = () => {

        const { idDemande, idDemandeADupliquer } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de la demande en cours..."
        });

        DataDemande._chargementDemande(idDemande || idDemandeADupliquer).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const reponseAPIobjet = responseFetch.reponseAPIobjet || {};
                const jDemande = reponseAPIobjet.demande || {};

                let demande = {};
                let destinataires = [];
                let typeDestinataireSelectionne = 0;
                let idSocieteSelectionne = 0;

                if (this._estFicheOuverteEnModeDuplication()) {
                    const { idOperation, idReservation, idTypeTransmission, dateDemande, idDemandeStandard } = jDemande;
                    demande = {
                        idOperation, idReservation, idTypeTransmission, dateDemande, idDemandeStandard,
                        demande: jDemande.demande
                    };
                }
                else if (this._estFicheOuverteEnModeModification()) {
                    demande = jDemande;
                    destinataires = reponseAPIobjet.destinataires || [];
                    typeDestinataireSelectionne = reponseAPIobjet.typeDestinataire || 0;
                    idSocieteSelectionne = typeDestinataireSelectionne === "operationnel" ? 1 : 0; // idSocieteSelectionne nécessaire au bon chargement de la ComboBoxCompte
                }

                const state = { demande, destinataires, typeDestinataireSelectionne, idSocieteSelectionne };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _chargementEmailDuCompte = (loginCompte) => {

        this.setState({ emailsSelectionnes: [] });

        DataCompte._chargementFicheCompte(loginCompte).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const reponseAPIobjet = responseFetch.reponseAPIobjet;
                const email = !!reponseAPIobjet && !!reponseAPIobjet.length && reponseAPIobjet[0].email;
                if (!!email) this.setState({ emailsSelectionnes: [email] })
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _chargementCommercialisateur = () => {

        this.setState({ emailsSelectionnes: [] });

        const { idOperation, idReservation } = this.state.demande;
        DataCommercialisation._onRechargementCommercialisationDeLaReservation(idOperation, idReservation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const reponseAPIobjet = responseFetch.reponseAPIobjet;
                const commercialisateur = !!reponseAPIobjet && !!reponseAPIobjet.length && reponseAPIobjet[0];
                if (!!commercialisateur) {
                    const { loginCompte, idSociete } = commercialisateur;
                    const newDestinataires = [{ loginCompte }];
                    this.setState(
                        {
                            destinataires: newDestinataires,
                            idSocieteSelectionne: idSociete || 0
                        },
                        () => {
                            this._chargementEmailDuCompte(loginCompte);
                            this._onVerificationFormulaire();
                        }
                    );
                }
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _chargementOperationDuPerimetre = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement du périmètre en cours"
        });

        Data._verificationSiPerimetreExiste().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const reponseAPIobjet = responseFetch.reponseAPIobjet;
                const idOperation = (!!reponseAPIobjet && reponseAPIobjet[0]) || 0;
                const demande = { ...this.state.demande, idOperation };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { demande });
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });

    };

    _enregistrer = (callback) => () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de la demande en cours..."
        });

        const { demande, destinataires } = this.state;

        DataDemande._onEnregistrementDemande(demande, destinataires)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const jDemande = responseFetch.reponseAPIobjet || {};
                    const state = { demande: { ...demande, idDemande: jDemande.idDemande } };

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, callback);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idDemande || this._estFicheOuverteEnModeDuplication();
    };

    _estFicheOuverteEnModeDuplication = () => {
        return !!this.props.idDemandeADupliquer;
    };

    _estFicheOuverteEnModeModification = () => {
        return !!this.props.idDemande;
    };

    _estPublipostageDejaEffectue = () => {
        const { rowGUID } = this.state.demande;
        return !!rowGUID && rowGUID !== "00000000-0000-0000-0000-000000000000";
    };

    _onChangeChoiceGroup = (event, option) => {
        const state = {
            destinataires: [],
            documentSelectionne: 0,
            emailsSelectionnes: [],
            idSocieteSelectionne: option.key === "operationnel" ? 1 : 0,
            onActiveBoutonEnregistrer: false,
            typeDestinataireSelectionne: option.key,
        };
        let callback = null;
        switch (option.key) {
            case "commercialisateur": if (!!this.state.demande.idReservation) callback = this._chargementCommercialisateur; break;
            default: break;
        };
        this.setState(state, callback);
    };

    _onOpen = () => {
        const { idOperation, idReservation } = this.props;
        const demande = { ...FicheDemande.defaultState.demande, idOperation, idReservation };

        let state = { ...FicheDemande.defaultState, demande };
        if (!!idReservation) state.typeDestinataireSelectionne = "client";

        let callback = this._estFicheOuverteEnModeCreation() && !this._estFicheOuverteEnModeDuplication()
            ? (!idOperation ? this._chargementOperationDuPerimetre : null)
            : this._chargementDonnees;

        this.setState(state, callback);
    };

    _onRenderFooterContent = () => {
        const { demande, onActiveBoutonEnregistrer, documentSelectionne, emailsSelectionnes } = this.state;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();
        const estPublipostageDejaEffectue = this._estPublipostageDejaEffectue();

        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._enregistrer(this.props.onEnregistrement)} disabled={!onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            {demande.idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && !estPublipostageDejaEffectue &&
                <PrimaryButton
                    disabled={!onActiveBoutonEnregistrer || !documentSelectionne}
                    onClick={this._enregistrer(this._publiposter)}
                    text="Enregistrer et générer courrier"
                />
            }
            {estFicheOuverteEnModeCreation && demande.idTypeTransmission === IDS_TYPE_TRANSMISSION.EMAIL &&
                <PrimaryButton
                    disabled={!onActiveBoutonEnregistrer || emailsSelectionnes.length === 0}
                    onClick={this._enregistrer(this._afficherPanelEnvoiEmail)}
                    text="Enregistrer et générer email"
                />
            }
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onSelectDate = (champs) => (event) => {
        const demande = { ...this.state.demande };
        const newDate = Scriba.date().getChaineISOFromDate(event, true);
        demande[champs] = newDate;

        this.setState(
            { demande },
            this._onVerificationFormulaire
        );
    };

    _onSend = (destinataires) => {
        const callback = () => this.setState({ afficherPanelEnvoiEmail: false }, this.props.onEnregistrement)
        this._updateDemande(
            { emails: destinataires.join(";") },
            this._enregistrer(callback)
        );
    };

    _onDismiss = () => {
        this.setState({ afficherPanelEnvoiEmail: false });
        this.props.onDismiss();
    }

    _onVerificationFormulaire = () => {
        const { demande, destinataires } = this.state;
        Immocom.fiche()._validationFormulaire(this, "Demande", { ...demande, destinataires }, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    _publiposter = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Génération du courrier en cours..."
        });

        const { demande, documentSelectionne } = this.state;

        DataDemande._onPublipostageDemande(demande.idDemande, documentSelectionne)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const document = responseFetch.reponseAPIobjet || {};
                    const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                    Scriba.fichier().EnregisterSous(fichier, document.nom);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _renderFormulaireDestinataire = () => {

        const { demande, destinataires, categorieIntervenantEXTPersonneSelectionnee, idIntervenantEXTSocieteSelectionne, idSocieteSelectionne, typeDestinataireSelectionne } = this.state;
        const { idOperation, idReservation } = demande;

        const loginCompte = (destinataires.find(d => !!d.loginCompte) || {}).loginCompte || "0"; // Pour le moment : un seul compte ne peut être sélectionné à la fois
        const idIntervenantEXTSociete = (destinataires.find(d => !!d.idIntervenantEXTSociete) || {}).idIntervenantEXTSociete || 0; // Pour le moment : un seul compte ne peut être sélectionné à la fois
        const idIntervenantEXTPersonne = (destinataires.find(d => !!d.idIntervenantEXTPersonne) || {}).idIntervenantEXTPersonne || 0; // Pour le moment : un seul compte ne peut être sélectionné à la fois
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

        let fields = [];
        let columns = [];

        if (!!typeDestinataireSelectionne) {

            const getComboBoxSociete = (disabled) => !!idOperation ?
                //<ComboBoxSocieteCommercialisante
                //    disabled={disabled}
                //    idOperation={idOperation}
                //    idReservation={idReservation}
                //    selectedKey={idSocieteSelectionne}
                //    key="societe"
                //    onChange={(event, option, index, value) => {
                //        this.setState({
                //            destinataires: [],
                //            emailsSelectionnes: [],
                //            idSocieteSelectionne: option.key,
                //            onActiveBoutonEnregistrer: false,
                //        });
                //    }}
                //    required
                ///>
                <ComboBoxSociete
                    commercialisante
                    disabled={disabled}
                    idOperation={idOperation}
                    idReservation={idReservation}
                    key="societe"
                    onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                    required
                    selectedKey={idSocieteSelectionne}
                />
                :
                <ComboBoxSociete
                    disabled={disabled}
                    idOperation={idOperation || null} // null forcé car seule valeur falsy attendue par ComboBoxSociete
                    key="societe"
                    onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                    required
                    selectedKey={idSocieteSelectionne}
                />
            //<ComboBoxSociete
            //    avecValeurDefaut
            //    disabled={disabled}
            //    idOperation={idOperation || null} // null forcé car seule valeur falsy attendue par ComboBoxSociete
            //    idSociete={idSocieteSelectionne}
            //    key="societe"
            //    label="Société"
            //    onChange={(event, option, index, value) => {
            //        this.setState({
            //            destinataires: [],
            //            emailsSelectionnes: [],
            //            idSocieteSelectionne: option.key,
            //            onActiveBoutonEnregistrer: false,
            //        });
            //    }}
            //    required
            ///>

            const getComboBoxCompte = (idTypeMandat) => {

                const getLabel = () => {
                    switch (idTypeMandat) {
                        case IDS_TYPE_MANDAT.COMMERCIALISATEUR: return "Commercialisateur";
                        case IDS_TYPE_MANDAT.OPERATIONNEL: return "Opérationnel";
                        default: return "Compte";
                    }
                };

                const getIdsTypesMandats = () => {
                    switch (idTypeMandat) {
                        case IDS_TYPE_MANDAT.COMMERCIALISATEUR: return [IDS_TYPE_MANDAT.COMMERCIALISATEUR];
                        case IDS_TYPE_MANDAT.OPERATIONNEL:
                            // Avant on ne chargeait que les comptes avec un mandat opérationnel
                            // Depuis on charge aussi les comptes d'autres mandats considérés comme opérationnels (ticket 1891)
                            return this.state.idsTypesMandatsOperationnels;
                        default: return [];
                    }
                };

                return !idOperation || idTypeMandat == IDS_TYPE_MANDAT.OPERATIONNEL ?
                    <ComboBoxCompte
                        disabled={!estFicheOuverteEnModeCreation || !idSocieteSelectionne}
                        idSociete={idSocieteSelectionne}
                        idsTypesMandats={getIdsTypesMandats()}
                        key="compte"
                        label={getLabel()}
                        onChange={(event, option, index, value) => {
                            const newDestinataires = option.key !== "0" ? [{ loginCompte: option.key }] : [];
                            this.setState({ destinataires: newDestinataires }, this._onVerificationFormulaire);
                            this._chargementEmailDuCompte(option.key);
                        }}
                        required
                        selectedKey={loginCompte}
                    />
                    :
                    <ComboBoxCompteCommercialisant
                        disabled={!estFicheOuverteEnModeCreation || !idSocieteSelectionne}
                        idOperation={idOperation}
                        idSociete={idSocieteSelectionne}
                        key="compte"
                        label={getLabel()}
                        onChange={(event, option, index, value, item) => {
                            const { loginCompte, email } = item;
                            const newDestinataires = [{ loginCompte }];
                            this.setState({
                                destinataires: newDestinataires,
                                emailsSelectionnes: [email]
                            }, this._onVerificationFormulaire);
                        }}
                        required
                        selectedKey={loginCompte}
                    />;

            }

            const getCheckBoxesContacts = () => {
                return <CheckboxesAcquereurs
                    disabled={!estFicheOuverteEnModeCreation}
                    idOperation={idOperation}
                    idReservation={idReservation}
                    key="client"
                    onChange={(selectedKeys, selectedContacts) => {
                        const newDestinataires = selectedKeys.reduce((destinataires, idContact) => [...destinataires, { idContact }], []);
                        let newEmails = selectedContacts
                            .filter(contact => !!contact.email)
                            .map(contact => contact.email);
                        newEmails = [...new Set(newEmails)];
                        this.setState({
                            destinataires: newDestinataires,
                            emailsSelectionnes: newEmails,
                        }, this._onVerificationFormulaire);
                    }}
                    selectedKeys={destinataires.filter(d => !!d.idContact).map(d => d.idContact)}
                />;
            };

            const getComboBoxIntervenantSociete = () => <ComboBoxIntervenantEXTSociete
                disabled={!estFicheOuverteEnModeCreation}
                key="intervenantEXTSociete"
                onChange={(event, option, index, value, item) => {
                    const { idIntervenantEXTSociete, email } = item;
                    const newDestinataires = [{ idIntervenantEXTSociete }];
                    this.setState({
                        destinataires: newDestinataires,
                        emailsSelectionnes: [email],
                    }, this._onVerificationFormulaire);
                }}
                onLoad={!!idIntervenantEXTSociete ? (item) => this.setState({ emailsSelectionnes: [item.email] }) : null}
                required
                selectedKey={idIntervenantEXTSociete}
            />;

            const getComboBoxCategorieIntervenantEXTPersonne = () => <ComboBoxCategorieIntervenantEXTPersonne
                key="categorieIntervenantEXTPersonne"
                onChange={(event, option, index, value, item) => {
                    this.setState({
                        categorieIntervenantEXTPersonneSelectionnee: option,
                        destinataires: [],
                        emailsSelectionnes: [],
                        idIntervenantEXTSocieteSelectionne: 0,
                        onActiveBoutonEnregistrer: false,
                    });
                }}
                selectedKey={categorieIntervenantEXTPersonneSelectionnee.key}
            />;

            const getComboBoxIntervenantSocieteDeLaPersonne = () => <ComboBoxIntervenantEXTSociete
                key="intervenantEXTSociete"
                onChange={(event, option, index, value, item) => {
                    this.setState({
                        destinataires: [],
                        emailsSelectionnes: [],
                        idIntervenantEXTSocieteSelectionne: option.key,
                        onActiveBoutonEnregistrer: false,
                    });
                }}
                selectedKey={idIntervenantEXTSocieteSelectionne}
            />;

            const getComboBoxIntervenantPersonne = () => <ComboBoxIntervenantEXTPersonne
                disabled={!estFicheOuverteEnModeCreation}
                idCategorieIntervenantEXTPersonne={categorieIntervenantEXTPersonneSelectionnee.key}
                idIntervenantEXTSociete={idIntervenantEXTSocieteSelectionne}
                key="intervenantEXTPersonne"
                onChange={(event, option, index, value, item) => {
                    const { idIntervenantEXTPersonne, email } = item;
                    const newDestinataires = [{ idIntervenantEXTPersonne }];
                    this.setState({
                        destinataires: newDestinataires,
                        emailsSelectionnes: [email],
                    }, this._onVerificationFormulaire);
                }}
                onLoad={!!idIntervenantEXTPersonne ? (item) => this.setState({ emailsSelectionnes: [item.email] }) : null}
                required
                selectedKey={idIntervenantEXTPersonne}
            />;

            switch (typeDestinataireSelectionne) {
                case "commercialisateur":
                    if (estFicheOuverteEnModeCreation) fields.push(getComboBoxSociete(false));
                    fields.push(getComboBoxCompte(IDS_TYPE_MANDAT.COMMERCIALISATEUR));
                    break;
                case "operationnel":
                    if (estFicheOuverteEnModeCreation) fields.push(getComboBoxSociete(true));
                    fields.push(getComboBoxCompte(IDS_TYPE_MANDAT.OPERATIONNEL));
                    break;
                case "client":
                    fields.push(getCheckBoxesContacts());
                    break;
                case "intervenantExtSociete":
                    fields.push(getComboBoxIntervenantSociete());
                    break;
                case "intervenantExtPersonne":
                    if (estFicheOuverteEnModeCreation) {
                        fields.push(getComboBoxCategorieIntervenantEXTPersonne());
                        fields.push(getComboBoxIntervenantSocieteDeLaPersonne());
                    }
                    fields.push(getComboBoxIntervenantPersonne());
                default: break;
            }

        }

        if (estFicheOuverteEnModeCreation) {
            columns = [
                <ChoiceGroup
                    disabled={!estFicheOuverteEnModeCreation}
                    label="Type de destinataire"
                    onChange={this._onChangeChoiceGroup}
                    options={[
                        { key: "commercialisateur", text: "Commercialisateur" },
                        { key: "operationnel", text: "Opérationnel" },
                        { key: "client", text: "Client", disabled: !idReservation },
                        { key: "intervenantExtSociete", text: "Société" },
                        { key: "intervenantExtPersonne", text: "Intervenant" },
                    ]}
                    required
                    selectedKey={typeDestinataireSelectionne}
                />,
                fields
            ];
        }
        else columns = fields;

        return <div className="ms-Grid-row">
            {columns.map((col, index) => <div key={index} className="ms-Grid-col ms-sm12 ms-lg6">{col}</div>)}
        </div>;

    };

    _telechargerDocument = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Téléchargement du courrier..."
        });

        DataDocument._onTelechargementDocument(this.state.demande.rowGUID).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {}, true);
                return Scriba.fichier().EnregisterSous(document, objetData.nom);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    };

    _updateDemande = (values, callback) => {
        const demande = { ...this.state.demande, ...values };
        this.setState(
            { demande },
            () => {
                this._onVerificationFormulaire();
                if (!!callback) callback();
            }
        );
    };

    _onChangeSociete = (value) => {
        this.setState({
            destinataires: [],
            emailsSelectionnes: [],
            idSocieteSelectionne: value,
            onActiveBoutonEnregistrer: false,
        });
    }

    componentDidMount = () => {
        // KP - 17/03/2022 - 1891 - Dans la ComboBox Opérationnels charger tous les mandats opérationnels (hors Commercialisateurs et hors WebServices)
        // _chargementTypeMandat(0) charge les TypeMandats autres que Commercialisateur et WebServices
        DataTypeMandat._chargementTypeMandat(0).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const typesMandats = responseFetch.reponseAPIobjet;
                const idsTypesMandatsOperationnels = typesMandats.map(typeMandat => typeMandat.idTypeMandat);
                FicheDemande.defaultState.idsTypesMandatsOperationnels = idsTypesMandatsOperationnels;
                this.setState({ idsTypesMandatsOperationnels });
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    render = () => {
        const { isOpen, onDismiss } = this.props;
        const { afficherPanelEnvoiEmail, sujet, typeDestinataireSelectionne, documentSelectionne, destinataires, emailsSelectionnes, from } = this.state;
        const { idOperation, idReservation, idTypeTransmission, dateDemande, idDemandeStandard, emails, demande, dateReponse, reponse, creerLe, creerPar, modifierLe, modifierPar } = this.state.demande;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();
        const estFicheOuverteEnModeModification = this._estFicheOuverteEnModeModification();
        const estPublipostageDejaEffectue = this._estPublipostageDejaEffectue();
        const estFicheOuverteDepuisOperation = !!this.props.idOperation;
        const estFicheOuverteDepuisReservation = !!this.props.idReservation;
        const aujourdhui = new Date(Date.now());

        const getSousCategorieDocument = () => {
            switch (typeDestinataireSelectionne) {
                case "client": return "Vers client";
                case "commercialisateur": return "Vers commercialisateur";
                case "intervenantExtPersonne": return "Vers intervenant ext. (personne)";
                case "intervenantExtSociete": return "Vers intervenant ext. (société)";
                case "operationnel": return "Vers opérationnel";
                default: return undefined;
            };
        };

        return <Fragment>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={estFicheOuverteEnModeCreation ? "Nouvelle demande" : "Modification d'une demande"}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.largeFixed}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxOperation
                                    disabled={!estFicheOuverteEnModeCreation || estFicheOuverteDepuisOperation}
                                    filtreSurMonPerimetre
                                    //idOperation={idOperation}
                                    idAgenceRequired={false}
                                    onChange={(event, option, index, value) => {
                                        const idOperation = option.key;
                                        if (!!idOperation) this.setState({ idSocieteSelectionne: 0 });
                                        this._updateDemande({ idOperation, idReservation: 0 });
                                    }}
                                    perimetre="eiffage"
                                    selectedKey={idOperation}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxReservation
                                    disabled={!idOperation || !estFicheOuverteEnModeCreation || estFicheOuverteDepuisReservation}
                                    idOperation={idOperation}
                                    onChange={(event, option, index, value) => {
                                        let state = { emailsSelectionnes: [] };
                                        if (!typeDestinataireSelectionne) state.typeDestinataireSelectionne = "client";
                                        else if (destinataires.length === 0); var callback = this._chargementCommercialisateur;
                                        this.setState(state);
                                        this._updateDemande({ idReservation: option.key }, callback);
                                    }}
                                    selectedKey={idReservation}
                                />
                            </div>

                        </div>
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxTypeTransmission
                                    disabled={!estFicheOuverteEnModeCreation}
                                    onChange={(event, option, index, value) => { this._updateDemande({ idTypeTransmission: option.key }); }}
                                    required
                                    selectedKey={idTypeTransmission}
                                />
                            </div>

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && !estPublipostageDejaEffectue &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <ComboBoxDocument
                                        categorie="Demande"
                                        disabled={!typeDestinataireSelectionne}
                                        idOperation={idOperation}
                                        label="Modèle de courrier"
                                        onChange={(event, option, index, value) => { this.setState({ documentSelectionne: option.key }); }}
                                        placeholder="Modèle de courrier"
                                        selectedKey={documentSelectionne}
                                        sousCategorie={getSousCategorieDocument()}
                                        type={TYPES_DOCUMENT.OPERATION}
                                    />
                                </div>
                            }

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && estPublipostageDejaEffectue &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <Label>Modèle de courrier</Label>
                                    <DefaultButton
                                        iconProps={{ iconName: "Download" }}
                                        text="Télécharger courrier publiposté"
                                        onClick={this._telechargerDocument}
                                        styles={{ root: { width: "100%", textAlign: "left" } }}
                                    />
                                </div>
                            }

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.EMAIL &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <PickerEmail
                                        disabled
                                        emails={estFicheOuverteEnModeCreation ? emailsSelectionnes : (emails || "").split(";")}
                                    />
                                </div>
                            }

                        </div>
                        <hr />

                        {this._renderFormulaireDestinataire()}

                        <hr />
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUIDatePicker
                                    disabled={estFicheOuverteEnModeModification}
                                    isRequired
                                    label="Demande effectuée le"
                                    onSelectDate={this._onSelectDate("dateDemande")}
                                    value={dateDemande}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxDemandeStandard
                                    disabled={estFicheOuverteEnModeModification}
                                    onChange={(event, option, index, value, item) => {
                                        this._updateDemande({ idDemandeStandard: option.key, demande: item.demandeStandard });
                                        this.setState({ sujet: item.titre });
                                    }}
                                    onLoad={(item) => this.setState({ sujet: item.titre })} // Utilisé dans le cadre de la duplication d'une demande
                                    required
                                    selectedKey={idDemandeStandard}
                                />
                            </div>

                        </div>
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    disabled={!idDemandeStandard}
                                    label="Demande"
                                    maxLength={MaxLengths.demande.demande}
                                    multiline
                                    onDelayedChange={(event, newValue) => { this._updateDemande({ demande: newValue }); }}
                                    readOnly={estFicheOuverteEnModeModification}
                                    rows={5}
                                    value={demande}
                                />
                            </div>

                        </div>
                        <hr />
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUIDatePicker
                                    disabled={!idDemandeStandard}
                                    label="Réponse réceptionnée le"
                                    maxDate={aujourdhui}
                                    onSelectDate={this._onSelectDate("dateReponse")}
                                    value={dateReponse}
                                />
                            </div>

                        </div>
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    disabled={!idDemandeStandard}
                                    label="Réponse"
                                    maxLength={MaxLengths.demande.reponse}
                                    multiline
                                    rows={5}
                                    onDelayedChange={(event, newValue) => { this._updateDemande({ reponse: newValue }); }}
                                    value={reponse}
                                />
                            </div>

                        </div>

                    </div>

                    {!estFicheOuverteEnModeCreation &&
                        <div className="divDateCreationModification">
                            {!!creerLe && !!creerPar && <div>Créée le {Scriba.date().stringDateFormatCourt(creerLe)} par {creerPar}</div>}
                            {!!modifierLe && !!modifierPar && <div>Modifiée le {Scriba.date().stringDateFormatCourt(modifierLe)} par {modifierPar}</div>}
                        </div>
                    }

                </Stack>

                <FicheEnvoiEmail
                    emails={emailsSelectionnes}
                    from={from}
                    corps={demande}
                    sujet={sujet}
                    isOpen={afficherPanelEnvoiEmail}
                    onDismiss={this._onDismiss}
                    onSend={this._onSend}
                />

            </Panel>

        </Fragment>;

    };

};